<script lang="ts">
  import { AccordionItem, Col,Accordion, CardBody } from "sveltestrap";
  import FeatherIcons from "svelte-feather-icon"
  import data from "../../../../Data/Users/Users.json"
  import { AboutMe } from "../../../../utils/Constant/Constant";
  import UserSocialNetwork from "./UserSocialNetwork.svelte";
</script>
<Col xl="12">
  <Accordion>
    <AccordionItem active header={AboutMe}>
      <CardBody class="post-about">
        <ul>
          {#each data.useraboutdata as userItem}
              <li>
                  <div class="icon"><FeatherIcons icon ={userItem.icon} /></div>
                  <div>
                      <h5>{userItem.header}</h5>
                      <p>{userItem.status}</p>
                  </div>
              </li>
          {/each}
        </ul>
        <UserSocialNetwork />
      </CardBody>
    </AccordionItem>
  </Accordion>
</Col>